import axios from '../axios';

//加载头文件
//import * as BaseMaterialQualityApi from './moudules/base/BaseMaterialQualityApi'; //物料质量标准
//  BaseMaterialQualityApi,//物料质量标准

// 物料质量标准列表
export const getBaseMaterialQualityPage = data => {
  return axios({
    url: '/api/sys/base/getBaseMaterialQualityPage',
    method: 'post',
    data
  })
};

// 物料质量标准保存
export const saveBaseMaterialQuality = data => {
  return axios({
    url: '/api/sys/base/saveBaseMaterialQuality',
    method: 'post',
    data
  })
};

// 物料质量标准修改
export const updateBaseMaterialQuality = data => {
  return axios({
    url: '/api/sys/base/updateBaseMaterialQuality',
    method: 'post',
    data
  })
};

// 物料质量标准删除
export const deleteBaseMaterialQualitys = data => {
  return axios({
    url: '/api/sys/base/deleteBaseMaterialQualitys',
    method: 'post',
    data
  })
};

// 物料质量标准查单条
export const getBaseMaterialQuality = data => {
  return axios({
    url: '/api/sys/base/getBaseMaterialQuality',
    method: 'post',
    data
  })
};

// 采购订单质检标准列表
export const getPurOrderQualityStandardPage = data => {
  return axios({
    url: '/api/sys/pur/getPurOrderQualityStandardPage',
    method: 'post',
    data
  })
};

// 采购订单质检标准列表保存
export const savePurOrderQualityStandard = data => {
  return axios({
    url: '/api/sys/pur/savePurOrderQualityStandard',
    method: 'post',
    data
  })
};
// 采购订单质检标准列表修改
export const updatePurOrderQualityStandard = data => {
  return axios({
    url: '/api/sys/pur/updatePurOrderQualityStandard',
    method: 'post',
    data
  })
};
// 采购订单质检标准列表删除
export const deletePurOrderQualityStandards = data => {
  return axios({
    url: '/api/sys/pur/deletePurOrderQualityStandards',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/BaseMaterialQualityApi.js